import React from 'react'
import styled from 'styled-components'

interface ButtonWithImageProps {
  text: string;
  textColor: string;
  imageSrc: string;
  fontSize: string;
  onClick?: () => void; // Adicione essa linha para a propriedade onClick
}

const ContentForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ButtonImage = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const Image = styled.img`
  width: 100px; /* Defina o tamanho desejado para a imagem */
  height: 100px; /* Defina o tamanho desejado para a imagem */
`;

const Label = styled.label<{ color: string; fontSize: string }>`
  font-size: ${(props) => props.fontSize};
  margin-top: 10px; /* Defina a distância entre a imagem e o texto */
  color: ${(props) => props.color};
`;

const ButtonWithImage: React.FC<ButtonWithImageProps> = ({
  text,
  textColor,
  imageSrc,
  fontSize,
  onClick, // Certifique-se de incluir onClick nas props
}) => {
  return (
    <ContentForm>
      <ButtonImage onClick={onClick}> {/* Atribua o evento onClick aqui */}
        <Image src={imageSrc} alt="Imagem do botão" />
      </ButtonImage>
      <Label color={textColor} fontSize={fontSize}>
        {text}
      </Label>
    </ContentForm>
  );
};

export default ButtonWithImage;
